<!-- Icon set. Inline rather than registered assets: they are 20px glyphs used
     only here, and the first-screen icon work already established that a
     round trip per glyph is not worth paying. -->
<ng-template #icon let-name>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <ng-container [ngSwitch]="name">
      <ng-container *ngSwitchCase="'overview'">
        <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
      </ng-container>
      <ng-container *ngSwitchCase="'people'">
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 19.5c.7-3 2.9-4.6 5.5-4.6s4.8 1.6 5.5 4.6" />
        <path d="M16 5.2a3.2 3.2 0 0 1 0 5.9M17.5 15.2c2 .5 3.3 2 3.8 4.3" />
      </ng-container>
      <ng-container *ngSwitchCase="'business'">
        <rect x="3" y="7.6" width="18" height="12.6" rx="2" />
        <path d="M9 7.6V6a1.8 1.8 0 0 1 1.8-1.8h2.4A1.8 1.8 0 0 1 15 6v1.6" />
        <path d="M3 12.6h18" />
      </ng-container>
      <ng-container *ngSwitchCase="'wealth'">
        <circle cx="12" cy="12" r="9" />
        <path
          d="M12 6.8v10.4M14.6 9.3c-.6-.7-1.6-1-2.6-1-1.5 0-2.6.8-2.6 2s1 1.7 2.6 2c1.7.3 2.7.8 2.7 2s-1.2 2-2.7 2c-1.1 0-2.1-.4-2.7-1.1"
        />
      </ng-container>
      <ng-container *ngSwitchCase="'health'">
        <path
          d="M20.4 6.9a4.7 4.7 0 0 0-7.1-.6l-1.3 1.3-1.3-1.3a4.7 4.7 0 0 0-7.1.6c-1.2 1.8-.9 4.3.7 5.9l7.7 7.6 7.7-7.6c1.6-1.6 1.9-4.1.7-5.9Z"
        />
      </ng-container>
      <ng-container *ngSwitchCase="'trends'">
        <path d="M3 16.5 9 10l4 4 8-8" />
        <path d="M15 6h6v6" />
      </ng-container>
      <ng-container *ngSwitchCase="'home'">
        <path d="M3.5 10.5 12 3.8l8.5 6.7" />
        <path d="M5.6 12.2v7.4a1 1 0 0 0 1 1h10.8a1 1 0 0 0 1-1v-7.4" />
        <path d="M9.8 20.6v-5.4h4.4v5.4" />
      </ng-container>
      <ng-container *ngSwitchCase="'heart'">
        <path d="M3.5 12.5h3.8l1.6-3.6 2.6 7.6 2.3-5.4 1.2 1.4h5.1" />
      </ng-container>
    </ng-container>
  </svg>
</ng-template>

<ng-template #lockGlyph>
  <svg viewBox="0 0 12 16" aria-hidden="true">
    <path
      d="M1.45 15.48c-.4 0-.74-.14-1.02-.41A1.35 1.35 0 0 1 0 14.09V6.87c0-.39.14-.71.42-.98.29-.28.63-.41 1.03-.41H2.4V3.94c0-.96.35-1.78 1.05-2.45A3.5 3.5 0 0 1 6 .48c1 0 1.85.34 2.55 1.01.7.67 1.05 1.49 1.05 2.45v1.54h.95c.4 0 .74.13 1.02.41.29.27.43.59.43.98v7.22c0 .38-.14.7-.43.98-.28.27-.62.41-1.02.41H1.45Zm0-1.15h9.1c.08 0 .14-.03.18-.07a.23.23 0 0 0 .07-.17V6.87a.23.23 0 0 0-.07-.17.25.25 0 0 0-.18-.07h-9.1a.25.25 0 0 0-.18.07.23.23 0 0 0-.07.17v7.22c0 .07.02.13.07.17.04.04.1.07.18.07ZM6 11.82c.39 0 .72-.13.99-.39.27-.26.41-.58.41-.95 0-.38-.14-.7-.41-.96A1.37 1.37 0 0 0 6 9.13c-.39 0-.72.13-.99.39-.27.26-.41.58-.41.96 0 .37.14.69.41.95.27.26.6.39.99.39ZM3.6 5.48h4.8V3.94c0-.65-.23-1.19-.7-1.64A2.4 2.4 0 0 0 6 1.63c-.67 0-1.23.22-1.7.67-.47.45-.7.99-.7 1.64v1.54Z"
      fill="currentColor"
    />
  </svg>
</ng-template>

<!-- "Click this one." Shown only while the getting-started guide is pointing
     at a row, in place of whatever glyph that row normally carries. -->
<ng-template #guideCursor>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M9 4 18 12.6l-4.2.3 1.8 4.2-2.2.9-1.8-4.2-3 2.9z"
      fill="currentColor"
    />
    <path
      d="M6.6 3.2 5.1 1.7M4.2 5.6 2.1 5.1M5.2 9 3.7 10.5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
    />
  </svg>
</ng-template>

<!-- Marks a row that repaints the map. Two stacked sheets: the same idea the
     map's own layer control uses. -->
<ng-template #mapGlyph>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M8 1.9 1.9 5.2 8 8.5l6.1-3.3L8 1.9Z" />
    <path d="M2.4 8.5 8 11.5l5.6-3" />
  </svg>
</ng-template>

<!-- One row: name and number on the top line, the gap from the US underneath. -->
<ng-template #metric let-row>
  <button
    type="button"
    class="metric metric--locked"
    *ngIf="row.lock"
    [class.is-free-lock]="row.lock.free"
    (click)="handleLockedClick(row)"
    [attr.data-cy]="'popup-locked-metric'"
    [attr.aria-label]="row.lock.aria + ' ' + row.label"
  >
    <span class="metric__head">
      <span class="metric__label">{{ row.label }}</span>
      <span class="metric__redacted" aria-hidden="true"></span>
    </span>
    <span class="metric__foot">
      <span class="metric__ref metric__ref--unlock">
        <span class="metric__lock">
          <ng-container *ngTemplateOutlet="lockGlyph"></ng-container>
        </span>
        {{ row.lock.phrase }}
      </span>
    </span>
  </button>

  <!-- A readable metric the map has a layer for: the row is the control that
       switches to it, so the number and the map agree without a trip to the
       right menu. -->
  <button
    type="button"
    class="metric metric--action"
    *ngIf="!row.lock && row.colorable"
    [class.is-on-map]="row.onMap"
    [class.guide-highlight]="guidedFeature === row.feature"
    [class.guide-highlight-pulse]="guidedFeature === row.feature && guidedPulse"
    [title]="row.note"
    [disabled]="row.onMap"
    (click)="handleColorByClick(row)"
    [attr.data-cy]="'popup-metric-action'"
    [attr.aria-label]="
      row.onMap
        ? row.label + ', on the map now'
        : 'Color the map by ' + row.label
    "
  >
    <ng-container
      *ngTemplateOutlet="metricBody; context: { $implicit: row }"
    ></ng-container>
  </button>

  <div
    class="metric"
    *ngIf="!row.lock && !row.colorable"
    [title]="row.note"
    [class.guide-highlight]="guidedFeature === row.feature"
    [class.guide-highlight-pulse]="guidedFeature === row.feature && guidedPulse"
  >
    <ng-container
      *ngTemplateOutlet="metricBody; context: { $implicit: row }"
    ></ng-container>
  </div>
</ng-template>

<!-- Shared by the two renderings above: only the element around it changes. -->
<ng-template #metricBody let-row>
  <span class="metric__head">
    <span class="metric__label">{{ row.label }}</span>
    <span class="metric__cursor" *ngIf="guidedFeature === row.feature">
      <ng-container *ngTemplateOutlet="guideCursor"></ng-container>
    </span>
    <span class="metric__flag" *ngIf="row.onMap">on the map</span>
    <span class="metric__paint" *ngIf="row.colorable && !row.onMap">
      <ng-container *ngTemplateOutlet="mapGlyph"></ng-container>
    </span>
    <span
      class="metric__value"
      [style.color]="row.grade ? row.grade.ink : null"
      >{{ row.value }}</span
    >
  </span>

  <!-- An index is already a ratio to the country, so there is no national tick
       to draw it against: it gets the score block's meter, filled by the same
       grade ramp, and the empty delta slot keeps its right edge in line with
       the bars on the rows around it. -->
  <span class="metric__foot" *ngIf="row.grade">
    <span class="meter__track meter__track--row">
      <span
        class="meter__fill"
        [style.width.%]="row.grade.fill"
        [style.background]="row.grade.base"
      ></span>
    </span>
    <span class="metric__delta" aria-hidden="true"></span>
    <span class="metric__ref">Graded against the US</span>
  </span>

  <span class="metric__foot" *ngIf="row.deviation && !row.grade">
    <span class="bar">
      <span class="bar__tick"></span>
      <span
        class="bar__fill"
        [ngClass]="'is-' + row.deviation.polarity"
        [style.left.%]="fillOffset(row.deviation)"
        [style.width.%]="fillWidth(row.deviation)"
      ></span>
    </span>
    <span class="metric__delta" [ngClass]="'is-' + row.deviation.polarity">
      {{ row.deviation.label }}
    </span>
    <span class="metric__ref">{{ row.reference }}</span>
  </span>
</ng-template>

<h4 class="place">{{ title }}</h4>

<!-- Above the tabs, not inside Overview: it qualifies every number in every
     tab, so it has to stay on screen whichever one is open. -->
<p class="caution" *ngIf="isMostlyWater">
  Mostly water. The numbers cover the administrative area around this cell.
</p>
<p class="caution" *ngIf="isTinyPopulation">
  Fewer than 10 residents. Read the demographics with care.
</p>

<!-- Subjects across, detail below. -->
<nav class="tabs" role="tablist" [attr.data-cy]="'popup-tabs'">
  <button
    type="button"
    role="tab"
    class="tab"
    [class.is-active]="isOverview"
    [attr.aria-selected]="isOverview"
    (click)="selectTab('overview')"
    [attr.data-cy]="'popup-tab-overview'"
  >
    <span class="tab__icon">
      <ng-container
        *ngTemplateOutlet="icon; context: { $implicit: 'overview' }"
      ></ng-container>
    </span>
    <span class="tab__label">Overview</span>
  </button>

  <button
    type="button"
    role="tab"
    class="tab"
    *ngFor="let tab of tabs; trackBy: trackById"
    [class.is-active]="activeTabId === tab.id"
    [attr.aria-selected]="activeTabId === tab.id"
    (click)="selectTab(tab.id)"
    [attr.data-cy]="'popup-tab-' + tab.id"
  >
    <span class="tab__icon">
      <ng-container
        *ngTemplateOutlet="icon; context: { $implicit: tab.icon }"
      ></ng-container>
      <span
        class="tab__lock"
        *ngIf="tab.lock"
        [class.is-free-lock]="tab.lock.free"
      >
        <ng-container *ngTemplateOutlet="lockGlyph"></ng-container>
      </span>
    </span>
    <span class="tab__label">{{ tab.label }}</span>
  </button>
</nav>

<div class="panel" role="tabpanel" [attr.data-cy]="'popup-panel'">
  <ng-container *ngIf="isOverview">
    <!-- The combined index, always against the country. The letter and its
         colour come from the same ramp the map paints the cell with. -->
    <section class="score" [attr.data-cy]="'popup-score'">
      <button
        type="button"
        class="score__grade score__grade--locked"
        *ngIf="heroLock"
        [class.is-free-lock]="heroLock.free"
        (click)="handleHeroLockedClick()"
        [attr.aria-label]="heroLock.aria + ' ' + heroTitle"
        [attr.data-cy]="'popup-score-locked'"
      >
        <span class="score__lock">
          <ng-container *ngTemplateOutlet="lockGlyph"></ng-container>
        </span>
      </button>

      <div
        class="score__grade"
        *ngIf="!heroLock"
        [style.color]="heroGrade ? heroGrade.ink : null"
      >
        {{ heroGrade ? heroGrade.letter : '–' }}
      </div>

      <div class="score__body">
        <!-- The (?) carries what the caption used to spell out, and it is the
             same hint the right menu shows for this indicator. -->
        <p class="score__name">
          {{ heroTitle }}
          <app-feature-tooltip
            class="score__hint"
            [tooltipText]="scoreDescription"
            [featureName]="heroTitle"
            tooltipPosition="below"
            (openTooltipModal)="handleScoreHintClick($event)"
          ></app-feature-tooltip>
        </p>

        <!-- Two renderings of the same three grades. The meters are the roomy one;
           below 768px the bar is dropped and the letter carries the grade on its
           own, which is what the colour is keyed to anyway. -->
        <ul class="score__chips">
          <li *ngFor="let sub of subIndices">
            {{ sub.label }}
            <b [style.color]="sub.grade ? sub.grade.ink : null">{{
              sub.locked ? '•' : sub.grade ? sub.grade.letter : '–'
            }}</b>
          </li>
        </ul>

        <ul class="score__meters">
          <li class="meter" *ngFor="let sub of subIndices">
            <span class="meter__label">{{ sub.label }}</span>
            <span class="meter__track">
              <span
                class="meter__fill"
                [style.width.%]="sub.grade ? sub.grade.fill : 0"
                [style.background]="sub.grade ? sub.grade.base : null"
              ></span>
            </span>
            <span
              class="meter__grade"
              [style.color]="sub.grade ? sub.grade.ink : null"
              >{{ sub.locked ? '•' : sub.grade ? sub.grade.letter : '–' }}</span
            >
          </li>
        </ul>

        <button
          type="button"
          class="score__caption score__caption--action"
          *ngIf="heroLock"
          [class.is-free-lock]="heroLock.free"
          (click)="handleHeroLockedClick()"
        >
          {{ heroLock.free ? 'Sign up free' : 'Unlock' }} to see the overall
          grade
        </button>
      </div>
    </section>

    <!-- The metric the map is coloured by right now: the answer to the click. -->
    <section
      class="focus"
      *ngIf="activeRow"
      [attr.data-cy]="'levels-popup-list'"
    >
      <!-- Name, number and gap on one line: this row is a caption for the map
           underneath, not the card's headline, and stacking it cost three lines
           of the panel's height budget for one metric. -->
      <div class="focus__line">
        <span class="focus__label">
          <span class="focus__name">{{ activeRow.label }}</span>
          <span class="focus__flag">on the map</span>
        </span>
        <span
          class="focus__value"
          *ngIf="!activeRow.lock"
          [attr.data-cy]="'levels-popup-list-value'"
          >{{
            isLoading && activeRow.value === 'N/A' ? 'Loading' : activeRow.value
          }}</span
        >
        <!-- The layer the map is painted with, behind the paywall: the pinned
             row is the one place the visitor has already asked the question, so
             it says what is missing and offers the way to it. -->
        <button
          type="button"
          class="focus__value focus__unlock"
          *ngIf="activeRow.lock"
          [class.is-free-lock]="activeRow.lock.free"
          (click)="handleLockedClick(activeRow)"
          [attr.data-cy]="'levels-popup-list-value'"
          [attr.aria-label]="activeRow.lock.aria + ' ' + activeRow.label"
        >
          <span class="focus__lock">
            <ng-container *ngTemplateOutlet="lockGlyph"></ng-container>
          </span>
          {{ activeRow.lock.phrase }}
        </button>
      </div>

      <!-- Same foot as every other row: the bar takes the slack, the gap sits
           in its own column, and the national figure right-aligns under the
           cell's own number. -->
      <div
        class="focus__foot"
        *ngIf="
          activeRow.deviation || (activeRow.reference && !activeLayerLevelNote)
        "
      >
        <span class="bar bar--wide" *ngIf="activeRow.deviation">
          <span class="bar__tick"></span>
          <span
            class="bar__fill"
            [ngClass]="'is-' + activeRow.deviation.polarity"
            [style.left.%]="fillOffset(activeRow.deviation)"
            [style.width.%]="fillWidth(activeRow.deviation)"
          ></span>
        </span>
        <span
          class="focus__delta"
          *ngIf="activeRow.deviation"
          [ngClass]="'is-' + activeRow.deviation.polarity"
          >{{ activeRow.deviation.label }}</span
        >
        <span
          class="focus__avg"
          *ngIf="activeRow.reference && !activeLayerLevelNote"
          >{{ activeRow.reference }}</span
        >
      </div>

      <p class="focus__ref" *ngIf="activeLayerLevelNote">
        {{ activeLayerLevelNote }}
      </p>
    </section>

    <section class="block" *ngIf="glance.length">
      <!-- Four plain numbers. The national comparison belongs on the rows
           below, where the US average is printed next to the value it is being
           compared with; up here it was four repetitions of the same phrase
           around figures most people read on their own. -->
      <h5 class="block__title">At a glance</h5>
      <ul class="glance">
        <li
          class="tile"
          *ngFor="let tile of glance; trackBy: trackByFeature"
          [class.is-on-map]="tile.onMap"
          [class.is-clickable]="tile.colorable && !tile.lock && !tile.onMap"
          [class.guide-highlight]="guidedFeature === tile.feature"
          [class.guide-highlight-pulse]="
            guidedFeature === tile.feature && guidedPulse
          "
        >
          <!-- Stretched over the tile rather than wrapped around it: the tile
               is a two-row grid, and a button in the middle of it would have to
               rebuild that layout to look identical. -->
          <button
            type="button"
            class="tile__hit"
            *ngIf="tile.colorable && !tile.lock && !tile.onMap"
            (click)="handleColorByClick(tile)"
            [attr.data-cy]="'popup-glance-action'"
            [attr.aria-label]="'Color the map by ' + tile.label"
          ></button>
          <span class="tile__icon">
            <ng-container
              *ngTemplateOutlet="icon; context: { $implicit: tile.icon }"
            ></ng-container>
          </span>
          <span class="tile__value" *ngIf="!tile.lock">{{ tile.value }}</span>
          <button
            type="button"
            class="tile__value tile__unlock"
            *ngIf="tile.lock"
            [class.is-free-lock]="tile.lock.free"
            (click)="handleLockedClick(tile)"
            [attr.data-cy]="'popup-locked-glance'"
            [attr.aria-label]="tile.lock.aria + ' ' + tile.label"
          >
            <span class="tile__lock">
              <ng-container *ngTemplateOutlet="lockGlyph"></ng-container>
            </span>
            {{ tile.lock.cta }}
          </button>
          <span class="tile__caption">
            <span class="tile__caption-text">{{ tile.caption }}</span>
            <span class="tile__cursor" *ngIf="guidedFeature === tile.feature">
              <ng-container *ngTemplateOutlet="guideCursor"></ng-container>
            </span>
          </span>
        </li>
      </ul>
    </section>

    <section class="block" *ngIf="standouts.length">
      <h5 class="block__title">Furthest from the US average</h5>
      <ng-container *ngFor="let row of standouts; trackBy: trackByFeature">
        <ng-container
          *ngTemplateOutlet="metric; context: { $implicit: row }"
        ></ng-container>
      </ng-container>
    </section>
  </ng-container>

  <ng-container *ngIf="!isOverview && activeTab as tab">
    <section
      class="block"
      *ngFor="let section of tab.sections; trackBy: trackByIndex"
    >
      <h5 class="block__title" *ngIf="section.label">{{ section.label }}</h5>
      <p class="block__note" *ngIf="section.note">{{ section.note }}</p>
      <ng-container *ngFor="let row of section.rows; trackBy: trackByFeature">
        <ng-container
          *ngTemplateOutlet="metric; context: { $implicit: row }"
        ></ng-container>
      </ng-container>
    </section>
  </ng-container>
</div>
